import axios from '@/utils/axios'
import {business, tenantUserPrefix} from '../../common'
import {getRoles} from '@/utils/cookie'
import {tenantUser} from '@/utils/role'

/**
 * 获取用户信息
 * @param NotNeedErrorMessage
 */
export const getSystemUserInfo = (NotNeedErrorMessage = false) => {
  return axios({
    url: `${business}/tenant/user/getUserInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {})
    },
    method: 'get'
  })
}

/**
 * 修改租户管理员信息
 * @param form
 */
export const editTenantAdmin = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/editTenantAdmin`,
    method: 'post',
    data: form
  })
}

/**
 * 获取当前租户的运营中列表
 * @param form -
 */
export const getPage = (pageInfo) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/getPage`,
    method: 'post',
    data: pageInfo
  })
}

/**
 * 审核
 * @param clinicCodes -
 * @returns {*} -
 */
export const approval = clinicCodes => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/approval`,
    method: 'post',
    data: clinicCodes
  })
}
/**
 * 添加租户人员信息
 * @param form
 */
export const addTenantUser = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/add`,
    method: 'post',
    data: form
  })
}

/**
 * 添加租户人员信息
 * @param form
 */
export const getTenantUserInfo = userCode => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/info/${userCode}`,
    method: 'get'
  })
}

/**
 * 修改租户人员信息
 * @param form
 * @returns {*}
 */
export const editTenantUserInfo = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/edit`,
    method: 'post',
    data: form
  })
}

/**
 * 删除租户人员信息
 * @param form
 * @returns {*}
 */
export const deleteTenantUser = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/delete`,
    method: 'delete',
    data: form
  })
}

/**
 * 校验身份证号是否重复（租户人员）
 * @param idNumber -
 * @param userCode -
 * @returns {*} -
 */
export const idNumberExists = (idNumber, userCode) => {
  return axios({
    url: `${business}/tenant/user/idNumberExists`,
    method: 'get',
    params: {idNumber, userCode}
  })
}

/**
 * 校验身手机号是否重复（租户人员）
 * @param phoneNumber -
 * @param userCode -
 * @returns {*} -
 */
export const phoneNumberExists = (phoneNumber, userCode) => {
  return axios({
    url: `${business}/tenant/user/phoneNumberExists`,
    method: 'get',
    params: {phoneNumber, userCode}
  })
}

/**
 * 校验登录名是否重复（租户人员）
 * @param loginName -
 * @param userCode -
 * @returns {*} -
 */
export const loginNameExists = (loginName, userCode) => {
  return axios({
    url: `${business}/tenant/user/loginNameExists`,
    method: 'get',
    params: {loginName, userCode}
  })
}

/**
 * 修改诊所运营者信息
 * 修改租户人员信息
 * @param form
 */
export const editTenantUser = form => {
  let url
  if (getRoles() === tenantUser) {
    url = `${business}${tenantUserPrefix}/tenant/user/editTenantAdmin`
  }
  return axios({
    url: url,
    method: 'post',
    data: form
  })
}

/**
 * 修改租户产品分类状态
 */
export const editEnableProduct = (editEnableProduct) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/${editEnableProduct}/editEnableProduct`,
    method: 'post'
  })
}

/**
 * 获取租户信息
 */
export const getPlatformTenantUserInfo = () => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/getPlatformTenantUserInfo`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/business/user/index.js